import { MIGRATED_INSTRUCTORS, NEW_APP_BASE_URL } from '@/config/migrated-instructors'

export const PRIMARY_LEGACY_HOST = 'app.swingmatch.ca'
export const ARCHIVE_LEGACY_HOST = 'old.swingmatch.ca'
export const BLACKHAWK_LEGACY_HOST = 'blackhawkacademy.swingmatch.ca'
export const EXTERNAL_REDIRECT_SESSION_KEY = '__sm_last_external_redirect__'
export const NEW_APP_AUTH_URL = NEW_APP_BASE_URL
export const BLACKHAWK_NEW_APP_URL = 'https://blackhawkacademy.swingmatchgolf.com/'

export type LegacyRedirectDecision = {
  reason: 'migrated-instructor' | 'account-route' | 'auth-entry' | 'guest-entry' | 'blackhawk-guest-entry'
  url: string
}

type RedirectInput = {
  hostname: string
  fullPath: string
  instructorId?: string
}

export function getRuntimeHostname(): string {
  return window.__SM_HOSTNAME_OVERRIDE__ || window.location.hostname
}

export function redirectToExternalUrl(url: string): void {
  if (window.__SM_CAPTURE_EXTERNAL_REDIRECTS__) {
    sessionStorage.setItem(EXTERNAL_REDIRECT_SESSION_KEY, url)
    return
  }

  window.location.replace(url)
}

export function shouldUseNewAppAuth(hostname = getRuntimeHostname()): boolean {
  return hostname === PRIMARY_LEGACY_HOST
}

export function redirectToNewAppAuth(): void {
  redirectToExternalUrl(NEW_APP_AUTH_URL)
}

export function getLegacyRedirectDecision({ hostname, fullPath, instructorId }: RedirectInput): LegacyRedirectDecision | null {
  if (hostname === BLACKHAWK_LEGACY_HOST && isBlackhawkGuestEntryRoute(fullPath)) {
    return {
      reason: 'blackhawk-guest-entry',
      url: BLACKHAWK_NEW_APP_URL,
    }
  }

  if (hostname !== PRIMARY_LEGACY_HOST) return null

  const migratedSlug = instructorId ? MIGRATED_INSTRUCTORS[instructorId] : null
  if (migratedSlug) {
    return {
      reason: 'migrated-instructor',
      url: `${NEW_APP_BASE_URL}/my/instructors/${migratedSlug}`,
    }
  }

  if (isGuestEntryRoute(fullPath)) {
    return {
      reason: 'guest-entry',
      url: NEW_APP_AUTH_URL,
    }
  }

  if (isAccountRoute(fullPath)) {
    return {
      reason: 'account-route',
      url: NEW_APP_AUTH_URL,
    }
  }

  if (isAuthEntryRoute(fullPath)) {
    return {
      reason: 'auth-entry',
      url: NEW_APP_AUTH_URL,
    }
  }

  return null
}

function isAccountRoute(fullPath: string): boolean {
  return fullPath === '/my' || fullPath.startsWith('/my/')
}

function isAuthEntryRoute(fullPath: string): boolean {
  const query = fullPath.split('?')[1]
  if (!query) return false

  return new URLSearchParams(query).get('show') === 'login'
}

function isBlackhawkGuestEntryRoute(fullPath: string): boolean {
  return fullPath === '/guest/home' || fullPath.startsWith('/guest/home?')
}

function isGuestEntryRoute(fullPath: string): boolean {
  return fullPath === '/' || fullPath === '/guest/home'
}
